import { render, staticRenderFns } from "./PDFZoom.vue?vue&type=template&id=48be887a"
import script from "./PDFZoom.vue?vue&type=script&lang=js"
export * from "./PDFZoom.vue?vue&type=script&lang=js"
import style0 from "./PDFZoom.vue?vue&type=style&index=0&id=48be887a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports